import React, { useMemo, useState, useEffect } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import ManualPdfViewer from "./ManualPdfViewer";
import styled from "styled-components";
import m from "definedMessages";
import { withTranslation } from "hoc/WithTranslation";


const Manual = ({ lang: actualLang, formatMessage }) => {
    const history = useHistory();

    const match = useRouteMatch("/manual/:lang");
    const { lang } = match ? match.params : {};

    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const fileUrl = useMemo(() => {
        if (!lang) {
            return null;
        }

        const fileName = lang === "ar"
            ? "Voice_SMS_panel_manual.AR.pdf"
            : "Voice_SMS_panel_manual.ENG.pdf";
        return `${process.env.PUBLIC_URL}/manuals/${fileName}#toolbar=0&navpanes=0&scrollbar=1`;
    }, [lang]);

    useEffect(() => {
        if (lang && lang !== actualLang) {
            history.replace(`/manual/${actualLang}`);
        }
    }, [actualLang, lang, history]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto",
        });
    }, [lang]);

    return (
        <ManualPage>
            <ViewerWrapper>
                <ManualHeader>
                    <div className="title">{formatMessage(m.manual)}</div>
                    <div className="page">{numPages > 0 ? `${pageNumber} / ${numPages}` : ""}</div>
                </ManualHeader>

                <ManualPdfViewer
                    fileUrl={fileUrl}
                    numPages={numPages}
                    pageNumber={pageNumber}
                    setNumPages={setNumPages}
                    setPageNumber={setPageNumber}
                />
            </ViewerWrapper>
        </ManualPage>
    );
};

export default withTranslation(Manual);

const ManualPage = styled.div`
    && {
        height: 100vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        overscroll-behavior: none;
    }
`;

const ViewerWrapper = styled.div`
    && {
        position: relative;
        flex: 1;
        min-width: 0;
        min-height: 0;
        overflow: hidden;
    }  
`;

const ManualHeader = styled.div`
    && {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;

        width: 100%;
        max-width: 1100px; /* має співпадати з max width PDF */

        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 12px 0;
        box-sizing: border-box;

        font-size: 22px;
        pointer-events: none; /* щоб не блокував wheel */
        
        .title {
            pointer-events: auto;
        }

        .page {
            pointer-events: auto;
        }
    }
`;